export class AdendaDTO{
  texto: string;
}
